import { render, staticRenderFns } from "./WebShopColorIntro.vue?vue&type=template&id=86a6e8bc"
import script from "./WebShopColorIntro.vue?vue&type=script&lang=js"
export * from "./WebShopColorIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports